import * as API from '../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readOne = async ({commit, dispatch}, {id}) => {
  try {
    const one = await API.readOne(id);
    commit('setOne', one);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const addGuests = async ({commit, dispatch}, {id, guests}) => {
  try {
    await API.addGuests(id, guests);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readGuests = async ({commit, dispatch}, {id}) => {
  try {
    const guests = await API.readGuests(id);
    commit('setGuests', guests);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const removeGuest = async ({commit, dispatch}, {id, trainingGuestId}) => {
  try {
    await API.removeGuest(id, trainingGuestId);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readTemplates = async ({commit, dispatch}, {id}) => {
  try {
    const templates = await API.readTemplates(id);
    commit('setTemplates', templates);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const createTemplate = async ({commit, dispatch}, {id, template}) => {
  try {
    await API.createTemplate(id, template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const updateTemplate = async ({commit, dispatch}, {id, template}) => {
  try {
    await API.updateTemplate(id, template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const removeTemplate = async ({commit, dispatch}, template) => {
  try {
    await API.removeTemplate(template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const update = async ({commit, dispatch}, training) => {
  try {
    await API.update(training);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const create = async ({commit, dispatch}, training) => {
  try {
    await API.create(training);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const remove = async ({commit, dispatch}, {id}) => {
  try {
    await API.del(id);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};


//
// @Action('admin/trainings/sendAllGuestsMail') private sendAllGuestsMail!: any;
// @Action('admin/trainings/sendConfirmedGuestsMail') private sendConfirmedGuestsMail!: any;
// @Action('admin/trainings/sendPendingGuestsMail') private sendPendingGuestsMail!: any;
// @Action('admin/trainings/sendTestMail') private sendTestMail!: any;
//

// @ts-ignore
export const sendAllGuestsMail = async ({commit, dispatch}, {trainingId, templateId}) => {
  try {
    await API.sendAllGuestsMail(trainingId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendConfirmedGuestsMail = async ({commit, dispatch}, {trainingId, templateId}) => {
  try {
    await API.sendConfirmedGuestsMail(trainingId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendPendingGuestsMail = async ({commit, dispatch}, {trainingId, templateId}) => {
  try {
    await API.sendPendingGuestsMail(trainingId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendTestMail = async ({commit, dispatch}, {trainingId, templateId}) => {
  try {
    await API.sendTestMail(trainingId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

export const updateCeo = async ({ commit, dispatch }, { trainingId, ceoId, capacity }) => {
  try {
    await API.updateCeo(trainingId, ceoId, capacity);
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};


export const sendMail = async ({ commit, dispatch }, { trainingId, templateId, ceos }) => {
  try {
    await API.sendMail(trainingId, templateId, ceos);
    dispatch('common/snackbar/success', 'Email wurde versandt', { root: true });
    return true;
  } catch (err: any) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};
